module.exports = "images/transparent-poster.png";